export default __webpack_public_path__ + "static/media/gold-plated-bangles.c3f38ae5.jpg";